export const PORTALS = [
  {id:'customer',label:'Müşteri Girişi',title:'Müşteri Girişi',destination:'/hesap'},
  {id:'dealer',label:'Bayi Portalı',title:'Bayi Girişi',destination:'/kurumsal'},
  {id:'management',label:'Yönetim Portalı',title:'Yönetim Girişi',destination:'/yonetim-merkezi'},
];
export function loginDestination(next) {
  if(next==='/yonetim-merkezi?demo=1'||next==='/yonetim-merkezi/?demo=1')return '/yonetim-merkezi?demo=1';
  return [...PORTALS.map(p=>p.destination),'/admin'].find(path=>next===path||next===path+'/')||'/hesap';
}
export function portalFor(next) {
  const destination=loginDestination(next).split('?')[0];
  return PORTALS.find(p=>p.destination===destination)||(destination==='/admin'?PORTALS[2]:PORTALS[0]);
}
export function portalHref(portal,user) {
  return user?portal.destination:'/giris?next='+encodeURIComponent(portal.destination);
}
